import React from 'react'

import { Col } from '../structure/Grid'
import { formatDate } from '../../../../utils/helpers/date'
import { useCalendar } from './CalendarHandler'
import CalendarEvent from './CalendarEvent'
import DayPlaceholder from './DayPlaceholder'
import Panel from '../structure/Panel'
import Text from '../presentation/Text'

const CalendarDay = ({ day, date, events }) => {
  const { onSelectDay, onSelectEvent } = useCalendar()
  const firstEvents = events.slice(0, 3)
  const restAmount = events?.length - firstEvents?.length
  const handleSelectDate = () => onSelectDay(date)

  return (
    <Panel
      width="14.285%"
      height={11}
      radius={0}
      gap={0.15}
      _bgColor={!day && 'light1'}
      borderColor={!day ? 'transparent' : 'light3'}
    >
      <Text align="right" bold onClick={handleSelectDate}>
        {day}
      </Text>

      {day && (
        <>
          <Col flex={1} />

          <DayPlaceholder />
          {firstEvents.map(event => (
            <CalendarEvent
              key={event.id}
              label={event.name}
              description={event.description}
              time={formatDate('HH:mm', event.date)}
              color={event.color}
              bgColor={event.checklist?.configuration?.calendarView?.backgroundColor}
              onClick={() => onSelectEvent(event)}
            />
          ))}

          {!!restAmount && (
            <CalendarEvent
              label={`+${restAmount} eventos`}
              bgColor="white"
              borderStyle="dashed"
              borderLeftStyle="dashed"
              borderLeftColor="light3"
              borderWidth="1px"
              noBorder={false}
              borderLeftWidth="1px"
              onClick={handleSelectDate}
            />
          )}
        </>
      )}
    </Panel>
  )
}

export default CalendarDay
